export const injectBigScript = (language: string, region: string): void => {
  const env = import.meta.env.VITE_CUSTOM_ENV;

  try {
    const script = document.createElement("script");

    script.src =
      env === "prod"
        ? "https://cdn.cmcmarkets.com/global/scripts/big-script/latest/cookies.js"
        : "https://uat-cdn.cmcmarkets.com/global/scripts/big-script/latest/cookies.js";
    script.type = "module";
    script.id = "cookies";
    script.setAttribute("data-region", region);
    script.setAttribute("data-service", "live-onboarding");
    script.setAttribute("data-pre-login", "false");
    script.setAttribute("data-language", language);

    document.head.appendChild(script);
  } catch (error) {
    console.error("Error injecting big script:", error);
  }
};
